import { render, staticRenderFns } from "./ClickAnimation.vue?vue&type=template&id=144ab94a&scoped=true"
import script from "./ClickAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./ClickAnimation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ClickAnimation.vue?vue&type=style&index=0&id=144ab94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144ab94a",
  null
  
)

export default component.exports